'use client'

import styled from "styled-components";
import BaseInput from "@/components/UI/Form/Inputs/BaseInput/BaseInput";

export const EmailInputStyled = styled(BaseInput)``